import { isEqual } from '../../utils/lang'
import { REGISTER_CONSENT } from './cmp.actionTypes'

export const registerConsent = consent => (dispatch, getState) => {
  if (!isEqual(getState()?.cmp?.consent, consent)) {
    dispatch({
      type: REGISTER_CONSENT,
      payload: consent
    })
  }
}
